import Residency from "./residency.jsx"

export default Residency